export class CallSessionModel {
  roomId: string;
  createdAt: number;
  id: string;
  clientId: string;
  startTime?: number;
  endTime?: number;
  duration?: number;
  status: CallSessionStatus;
  callerId: string;
  csId?: string;
  expirationTime: number;
  remoteId: string;
  sdp?: string;
  constructor(_model: CallSessionModel) {
    if (
      !_model.roomId ||
      !_model.id ||
      !_model.clientId ||
      !_model.callerId ||
      !_model.remoteId
    ) {
      throw new Error("Required fields are missing");
    }
    if (!this.isCallSessionStatus(_model.status)) {
      throw new Error("Invalid call session status");
    }

    this.roomId = _model.roomId;
    this.createdAt = _model.createdAt;
    this.id = _model.id;
    this.clientId = _model.clientId;
    this.startTime = _model.startTime;
    this.endTime = _model.endTime;
    this.duration = _model.duration;
    this.status = _model.status;
    this.callerId = _model.callerId;
    this.csId = _model.csId;
    this.expirationTime = _model.expirationTime;
    this.remoteId = _model.remoteId;
    this.sdp = _model.sdp;
  }

  isCallSessionStatus(status: any): status is CallSessionStatus {
    return Object.values(CallSessionStatus).includes(status);
  }
}

export enum CallSessionStatus {
  RINGING = "RIN",
  ANSWERED = "ANS",
  REJECTED = "RJC",
  FAILED = "FAI",
  COMPLETED = "CMP",
  NO_ANSWER = "NOA",
  HOLD = "HLD",
}
